import React from "react";
import { Modal } from "antd";
import { Button } from "./button/Button";
import { InfoCircleOutlined } from "@ant-design/icons";

const SurveyModal = ({ visible, onCancel }) => {
  const handleLater = () => {
    onCancel();
  };

  const handleKnowMore = () => {
    window.open("https://mailchi.mp/apas.asso.fr/consultation-apas-et-vous-adherents-10-09-25", "_blank");
    // Ne pas fermer la modal
  };

  const handleSurveyResponse = () => {
    window.open("https://apasetvous.fr", "_blank");
    // Ne pas fermer la modal
  };

  return (
    <Modal
      title={
        <div>
          <InfoCircleOutlined style={{ color: "#1890ff", marginRight: 8 }} />
          Votre avis compte vraiment pour nous !
        </div>
      }
      open={visible}
      onCancel={handleLater}
      maskClosable={false}
      footer={[
        <Button
          key="respond"
          type="submit"
          onClick={handleKnowMore}
          style={{ minWidth: '120px', marginRight: 30 }}
        >
          En savoir +
        </Button>,
        <Button
          key="respond"
          type="submit"
          onClick={handleSurveyResponse}
          style={{ minWidth: '200px' }}
        >
          J'accède au questionnaire
        </Button>,
      ]}
      width={800}
      styles={{
        footer: {
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px',
          padding: '14px 24px'
        }
      }}
    >
      <div style={{ marginBottom: 16 }}>
        <p>
          Aidez-nous à mieux vous accompagner en partageant votre expérience dans notre <strong>Questionnaire Adhérents</strong>.<br />
          Quelques minutes suffisent pour nous aider à adapter nos services à vos besoins réels.
        </p>
        <p>
          Vous avez jusqu'au <strong>5 octobre</strong> pour participer.
        </p>
      </div>
    </Modal>
  );
};

export default SurveyModal;